import { RESERVED_HOT_PINK } from '@/uptk/core/packages/style/internal/reserved';

const color = {
  unknown: RESERVED_HOT_PINK,
  unsupported: RESERVED_HOT_PINK,
  white: '#ffffff',
  black: '#000000',
  get purple () {
    return this.purple500;
  },
  get blue () {
    return this.blue500;
  },
  get teal () {
    return this.teal500;
  },
  get green () {
    return this.green500;
  },
  get orange () {
    return this.orange500;
  },
  get red () {
    return this.red500;
  },
  get mint () {
    return this.mint500;
  },
  get brown () {
    return this.brown500;
  },

  color1: '#ef3341',
  color2: '#e68269',
  color3: '#194F4F',
  color4: '#25A0A8',


  mint50: '#A8E9E0',
  mint100: '#90E3D7',
  mint200: '#7CDDD0',
  mint300: '#58D4C3',
  mint400: '#42CEBA',
  mint500: '#21C6AF',
  mint600: '#20B5A0',
  mint700: '#1AA390',
  mint800: '#158374',
  mint900: '#116E62',

  brown50: '#F7F4F1',
  brown100: '#F3EEE8',
  brown200: '#E3DED7',
  brown300: '#D9C3CC',
  brown400: '#ADA296',
  brown500: '#7D6C5A',
  brown600: '#614E37',
  brown700: '#513C24',
  brown800: '#3A2206',
  brown900: '#2B1904',

  red10: '#FFE3E0',
  red20: '#FFCFC9',
  red30: '#FFBBB2',
  red40: '#FFA79C',
  red50: '#FF9485',
  red100: '#FF806F',
  red200: '#FF6C58',
  red300: '#FF5942',
  red400: '#ED412A',
  red500: '#E32B16',
  red600: '#C42010',
  red700: '#A6150B',
  red800: '#880A05',
  red900: '#6A0000',

  orange10: '#FFE8BF',
  orange20: '#FEDFA6',
  orange30: '#FED68E',
  orange40: '#FECD76',
  orange50: '#FEC55E',
  orange100: '#FAB551',
  orange200: '#F6A544',
  orange300: '#F29538',
  orange400: '#EE852B',
  orange500: '#EA7319',
  orange600: '#E06519',
  orange700: '#D65513',
  orange800: '#CC440D',
  orange900: '#C23407',

  green10: '#D1F4C9',
  green20: '#B8E8B6',
  green30: '#A0DDA4',
  green40: '#88D291',
  green50: '#70C77F',
  green100: '#5DBD74',
  green200: '#4DB469',
  green300: '#3CAB60',
  green400: '#309C5A',
  green500: '#24874B',
  green600: '#18723D',
  green700: '#0C5D2E',
  green800: '#014920',
  green900: '#003912',

  teal10: '#DAF0F0',
  teal20: '#C7E8E8',
  teal30: '#B4E0E1',
  teal40: '#A2D9DA',
  teal50: '#8DCDD1',
  teal100: '#7BC1C8',
  teal200: '#63B5C0',
  teal300: '#49A0AC',
  teal400: '#3095A6',
  teal500: '#008297',
  teal600: '#1B6B85',
  teal700: '#005571',
  teal800: '#014156',
  teal900: '#00314C',

  blue10: '#CBE7F9',
  blue20: '#B7DEF6',
  blue30: '#A4D5F4',
  blue40: '#90CCF2',
  blue50: '#7DC3F0',
  blue100: '#64B1E4',
  blue200: '#4B9FD8',
  blue300: '#338DCD',
  blue400: '#2D81BD',
  blue500: '#2670A9',
  blue600: '#155C93',
  blue700: '#00477B',
  blue800: '#0C3566',
  blue900: '#002858',

  purple10: '#F9E0F7',
  purple20: '#F7D4F4',
  purple30: '#F5C9F1',
  purple40: '#F3BDEE',
  purple50: '#F1B2EB',
  purple100: '#DF9CE1',
  purple200: '#CD87D7',
  purple300: '#C074CB',
  purple400: '#A961D5',
  purple500: '#964EA2',
  purple600: '#813C8D',
  purple700: '#672E7A',
  purple800: '#53256D',
  purple900: '#3B1054',

  grey10: '#F2F4F6',
  grey20: '#EAEDEF',
  grey30: '#E0E4E9',
  grey40: '#D9DDE3',
  grey50: '#CED2D9',
  grey60: '#C5C9D0',
  grey70: '#B4B7BE',
  grey80: '#9FA3AA',
  grey90: '#84878E',
  grey100: '#74777F',
  grey200: '#61656E',
  grey300: '#4C505B',
  grey400: '#44484F',
  grey500: '#3B3F46',
  grey600: '#2F3136',
  grey700: '#2A2C2F',
  grey800: '#242526',
  grey900: '#161616'
};

export default color;
